import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import PropTypes from 'prop-types';

import { commonActions } from '../../../global-store/subjects/common';
import logger from '../../../services/logging/logging-service';
import { isIos } from '../../../utils/device-utils';
import {
  checkExpirationOnLocalStorage,
  WPN_STATUS,
  WPN_DAILY_SESSION,
  setStatusOnLocalStorage,
  WPN_SUBSCRIPTION,
} from '../../../utils/local-storage';
import { isEmptyObject, printObject } from '../../../utils/object-utils';

import { getHandlers } from './getters/get-handlers';

const AutoPushNotifications = ({
  htmlProps,
  state,
  actions,
  pageActions,
  elementIdInPage,
  render,
  initCallback,
  blockInPageType,
  isActiveInPage,
}) => {
  const handlers = getHandlers({ state, actions, pageActions });

  useEffect(() => {
    checkExpirationOnLocalStorage(WPN_STATUS, WPN_DAILY_SESSION);

    const commonInit = (async () => {
      try {
        actions.setIsLoading(true);
        if (isEmptyObject(window.UA) || isIos()) {
          throw new Error('[WPN] UA is empty. Cannot initialize Push Notification.');
        }
        const sdk = await window.UA;
        actions.setSdk(sdk);
        actions.setIsLoading(false);
      } catch (error) {
        actions.setSdk(null);
        commonActions.setPushNotificationInDialogShow(false);
        logger.error(error);
        actions.setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (state.sdk) {
      if (state.sdk.channel?.optedIn) {
        setStatusOnLocalStorage({ key: WPN_SUBSCRIPTION.OBJECT_KEY, name: WPN_SUBSCRIPTION.SUBSCRIBED.NAME });
      }
      initCallback({
        actions,
        pageActions,
        htmlProps,
        selectBoxes: htmlProps.selectBoxes,
        sdk: state.sdk,
        handlers,
        onShowConfirmModal: handlers.handleShowConfirmModal,
        elementIdInPage,
      });
    }
  }, [state.sdk]);

  if (!state.sdk) {
    return null;
  }

  return render({
    state,
    handlers,
    htmlProps,
    pageActions,
    blockType: blockInPageType,
    elementIdInPage,
    isActiveInPage,
  });
};

AutoPushNotifications.propTypes = {
  htmlProps: PropTypes.shape({
    confirmDialogDescriptionText: PropTypes.string,
    position: PropTypes.string,
    selectBoxes: PropTypes.array.isRequired,
  }),
  state: PropTypes.object.isRequired,
  pageState: PropTypes.object,
  actions: PropTypes.object.isRequired,
  pageActions: PropTypes.object,
  render: PropTypes.func.isRequired,
  init: PropTypes.func,
  isActiveInPage: PropTypes.bool,
  blockInPageType: PropTypes.string,
};

export default AutoPushNotifications;
